import Label from '@/components/core/label';
import { useTranslation } from 'react-i18next';
import { ChoicesStatusSalesOrder } from '@/types';

import type { Theme, SxProps } from '@mui/material/styles';
type Props = {
  status: ChoicesStatusSalesOrder | string | undefined;
  sx?: SxProps<Theme>;
};

const STATUS_COLOR_MAP: Record<string, 'warning' | 'success' | 'default'> = {
  [ChoicesStatusSalesOrder.pending_invoiced]: 'warning',
  [ChoicesStatusSalesOrder.invoiced]: 'success',
};

const STATUS_LABEL_MAP: Record<string, string> = {
  [ChoicesStatusSalesOrder.pending_invoiced]: 'Pending Invoiced',
  [ChoicesStatusSalesOrder.invoiced]: 'Invoiced',
};

/**
 * Displays a status label for a sales order, excluding the 'active' status.
 * Centralizes color and label mapping for ChoicesStatusSalesOrder.
 */
export function SalesOrderStatusLabel({ status, sx }: Props) {
  const { t } = useTranslation();

  if (!status || status === ChoicesStatusSalesOrder.active) return null;

  return (
    <Label color={STATUS_COLOR_MAP[status] ?? 'default'} sx={{ fontSize: '0.7rem', ...sx }}>
      {STATUS_LABEL_MAP[status] ? t(STATUS_LABEL_MAP[status]) : status}
    </Label>
  );
}
